import gql from 'graphql-tag'

export default gql`
  query listWorkflows($projectId: String!) {
    listWorkflows(projectId: $projectId) {
      project {
        workflows {
          id
          projectId
          name
          starred
          version
          thumbnail
          updatedAt
          status
        }
      }
    }
  }
`
